import React, { useState, useEffect } from 'react';
import {
  Box,
  Container,
  makeStyles
} from '@material-ui/core';
import Page from 'src/components/Page';
import Toolbar from './Toolbar';
import Firebase from 'src/Firebase.js'
import DispatchTableWrapper from './DispatchTableWrapper';


const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));


const DispatchListView = () => {
  const classes = useStyles();


  useEffect(() => {
    // Update the document title using the browser API

    
  });


  return (
    <Page
      className={classes.root}
      id="Dispatch"
      title="Dispatch"
    >
      <Container maxWidth={false}>
        <Toolbar />
        <Box mt={3}>
         <div id='fk121'>
          <DispatchTableWrapper />
          </div>
          

        </Box>
      </Container>
    </Page>
  );
};

export default DispatchListView;
